import React from 'react';
import type { LucideIcon } from 'lucide-react';

interface AppLauncherItemProps {
  Icon: LucideIcon;
  title: string;
  url: string;
  backgroundColor: string;
}

const AppLauncherItem: React.FC<AppLauncherItemProps> = ({ Icon, title, url, backgroundColor }) => {
  return (
    <div
      className="appLauncherTile"
      style={{ backgroundColor }}
      onClick={() => window.open(url, '_blank')}
    >
      <Icon className="h-8 w-8 text-white" />
      <span className="text-white text-xs">{title}</span>
    </div>
  );
};

export default AppLauncherItem;
